var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import LanguagePickerDesktop from "./LanguagePickerDesktop";
import LanguagePickerMobile from "./LanguagePickerMobile";
import "./LanguagePicker.types";
var LanguagePicker = function (_a) {
    var variant = _a.variant, languagePickerProps = __rest(_a, ["variant"]);
    return variant === "desktop" ? (React.createElement(LanguagePickerDesktop, __assign({}, languagePickerProps))) : (React.createElement(LanguagePickerMobile, __assign({}, languagePickerProps)));
};
export default LanguagePicker;
